import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useBrand } from "@/contexts/BrandContext";
import { GUIDED_TOUR_SWITCH_KEY, guidedTourDefault, isGuidedTourOn } from "@/lib/guided-tour-switch";

export async function fetchGuidedTourSwitch(brandId: string): Promise<boolean> {
  const { data, error } = await supabase
    .from("platform_settings")
    .select("value")
    .eq("key", GUIDED_TOUR_SWITCH_KEY)
    .eq("brand", brandId)
    .maybeSingle();
  if (error) throw new Error(error.message);
  return isGuidedTourOn(brandId, data?.value);
}

export function useGuidedTourSwitch(): { enabled: boolean; loading: boolean } {
  const brand = useBrand();
  const { data, isLoading, isError } = useQuery({
    queryKey: ["guided-tour-switch", brand.id],
    queryFn: () => fetchGuidedTourSwitch(brand.id),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  if (isLoading) return { enabled: false, loading: true };
  if (isError || data === undefined) return { enabled: guidedTourDefault(brand.id), loading: false };
  return { enabled: data, loading: false };
}
